<template>
  <v-expand-transition>
    <div class="story-fields" v-show="showExtraFields">
      <div class="column">
        <template>
          <div class="meta-chips" v-for="(tag, index) in fields" :key="index">
            <v-chip class="meta-chip" label v-if="tag.label">
              {{ extraFieldContent(tag) }}
            </v-chip>
          </div>
        </template>
      </div>
    </div>
  </v-expand-transition>
</template>

<script>
export default {
  name: 'ExpandedExtraFieldsComponent',
  props: {
    fields: {
      type: Array,
      default: () => [],
    },
    showExtraFields: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    extraFieldContent(tag) {
      let value = '';
      if (tag.type === 'checkboxcell') {
        value = tag.value === 'true' ? '☑' : '☐';
      } else {
        value = tag.value ? tag.value : '---';
      }
      return `${tag.label} : ${value}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/fixes.scss';

// Metadados
.story-fields {
  width: 100%;
  padding: 16px;
  background-color: $color-black-04;
  border-top: solid 1px $color-black-08;

  // Controle de inputs
  ::v-deep .v-input {
    .v-input__control {
      .v-input__slot {
        label {
          font-size: 0.88em !important;
          margin-top: 1px;
        }
      }
    }
    &.v-input--checkbox,
    .v-input--is-label-active {
      label {
        left: 0px !important;
      }
      margin-top: 0;
      height: 56px;
      border-radius: 4px !important;
      background-color: $color-white;
      display: flex;
      align-items: center;
      .v-input--selection-controls__input {
        margin-left: 12px;
      }
    }

    &.v-input--is-focused {
      .v-input__control {
        .v-input__slot {
          .v-text-field__slot {
            label {
              display: none;
            }
          }
        }
      }
    }
  }

  .meta-chips {
    background-color: $color-black-04;
    padding: 4px 8px;
    border-radius: 4px;

    .meta-chip {
      background-color: transparent;
      padding: 0;
      font-family: 'globotipo' !important;
      font-weight: 500 !important;
      font-size: 0.8em;
      color: $color-black-56;
      text-transform: lowercase;
    }
  }
}
</style>
